<template lang="html">
<div>
     <div class="inner-page">
          <Header>
              <div>关于音网</div>
          </Header>
          <div class="page-content">
              <img :src="logoUrl" alt="">
          </div>
          <Footer />
     </div>
</div>
</template>
<script>
import imgUrl from "@/assets/logo3.png";
export default {
    data(){
        return{
             logoUrl:imgUrl
        }
    }
}
</script>

<style lang="css">

.page-content{
    text-align: center;
    background: white;
    padding: 45px 0;
}

.page-content img{
    height: 145px;
}

</style>
